module.exports = __webpack_public_path__ + "img/alipayhk_logo.47da6ce1.svg";